import axios from 'axios'

class ConnectedHealthService {
  constructor() {
    this.url = '/api/v1/'
  }

  get1UpHealthUserDetails(id) {
    return axios.get(`${this.url}oneuphealth/user/?user_id=${id}`)
  }

  deleteConnectedProviders(params) {
    return axios.delete(
      `${this.url}oneuphealth/provider/?user_id=${params.user_id}&patient_id=${params.patient_id}`,
      {
        headers: { Authorization: `Bearer ${params.token}` },
      }
    )
  }
}

export const connectedHealthService = new ConnectedHealthService()
